import { render, staticRenderFns } from "./ModalBuatTemuan.vue?vue&type=template&id=4bd7637a&"
import script from "./ModalBuatTemuan.vue?vue&type=script&lang=js&"
export * from "./ModalBuatTemuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports